import commonActions from '@/common/store/actions'

const customActions = {}

export default Object.assign(
  {},
  commonActions,
  customActions
)
